import React, { useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Contact.css"; // Custom CSS for additional styling
import emailjs from '@emailjs/browser'
import Header from "../Components/Header";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";

const ContactView = () => {

    const form = useRef();
    const navigate = useNavigate();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs
            .sendForm(
                "service_8pcwo5r", // ID du service configuré dans EmailJS
                "template_co04kic", // ID du modèle d'e-mail
                form.current,
                "-E6m0V0-AbxOWgsXt" // Clé publique EmailJS
            )
            .then(
                (result) => {
                    console.log("Message envoyé : ", result.text);
                    navigate("/merci");
                },
                (error) => {
                    console.error("Erreur lors de l'envoi : ", error);
                    alert("Une erreur s'est produite.");
                }
            );
    };

    return (
        <>
            <Helmet>
                <title>Contact</title>
                <meta name="description" content="Contact" />
                <meta name="robots" content="index, follow" />
            </Helmet>
            <Header title={"Contact"}></Header>
            <div className="container my-5 contact-form-container">
                <div className="row">
                    {/* Form Section */}
                    <div className="col-md-8">
                        <p className="instructions">
                            Pour nous contacter, utilisez l’une des solutions suivantes : le
                            formulaire, le mail, le téléphone. Nous vous recontacterons dans les
                            plus brefs délais.
                        </p>
                        <form
                            onSubmit={sendEmail}
                            className="needs-validation"
                            ref={form}
                            noValidate
                        >
                            <div className="mb-3">
                                <label htmlFor="nom" className="form-label">
                                    Nom <span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="nom"
                                    name="nom"
                                    placeholder="Votre nom"
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="prenom" className="form-label">
                                    Prénom <span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="prenom"
                                    name="prenom"
                                    placeholder="Votre prénom"
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="email" className="form-label">
                                    Adresse email <span className="required">*</span>
                                </label>
                                <input
                                    type="email"
                                    className="form-control"
                                    id="email"
                                    name="email"
                                    placeholder="Votre email"
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="telephone" className="form-label">
                                    Téléphone <span className="required">*</span>
                                </label>
                                <input
                                    type="tel"
                                    className="form-control"
                                    id="telephone"
                                    name="telephone"
                                    placeholder="Votre téléphone"
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="message" className="form-label">
                                    Objet de la demande <span className="required">*</span>
                                </label>
                                <textarea
                                    className="form-control"
                                    id="message"
                                    name="message"
                                    rows="4"
                                    placeholder="Décrivez votre demande"
                                    required
                                ></textarea>
                            </div>
                            <div className="d-grid">
                                <button type="submit" className="btn btn-primary custom-btn">
                                    Envoyer
                                </button>
                            </div>
                        </form>
                    </div>
                    {/* Information Section */}
                    <div className="col-md-4 contact-info">
                        <h4>Coordonnées</h4>
                        <p>
                            <strong>Fixe :</strong>{" "}
                            <a href="tel:0951092832">09.51.09.28.32</a>
                        </p>

                        <p>
                            <strong>Email :</strong>{" "}
                            <a href="mailto:contact@scfps.fr">contact@scfps.fr</a>
                        </p>
                        <p>
                            <strong>Adresse :</strong> 17 Rue Jules Delsart, 59300 Valenciennes
                        </p>
                        <h5>Liens Extranet</h5>
                        <ul className="list-unstyled">
                            <li>
                                <a href="https://sc-formation-prevention-secours.hop3team.com/learners/sign_in" className="text-primary">
                                    Accès Participant
                                </a>
                            </li>
                            <li>
                                <a href="https://sc-formation-prevention-secours.hop3team.com/speakers/sign_in" className="text-primary">
                                    Accès Formateur
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ContactView;